import { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';

import { Button } from '~ui-kit';

const propTypes = {
  onRead: PropTypes.func.isRequired,
  label: PropTypes.string,
};

class QRCodeReader extends Component {
  state = {
    errorMessage: null,
  };

  handleScanSuccess = ({ text, cancelled }) => {
    if (cancelled) {
      console.log('Barcode scanning cancelled...');
      this.setState({ errorMessage: 'Luku keskeytetty' });
      return;
    }

    if (!text) {
      console.log('No result from barcode scanning...');
      this.setState({ errorMessage: 'Laitetta ei löytynyt' });
      return;
    }

    this.props.onRead(text);
  };

  handleScanFailure = error => {
    console.log(`Scanning failed: ${error}`);
    this.setState({ errorMessage: 'QR- tai viivakoodin luku epäonnistui' });
  };

  scanBarcode = () => {
    if (window.cordova) {
      const options = {
        showTorchButton: true, // iOS and Android
        prompt: 'Aseta viivakoodi etsintäalueen sisälle', // Android
        resultDisplayDuration: 0,
        disableAnimations: true, // iOS
        disableSuccessBeep: false, // iOS,
        orientation: 'portrait',
        // TODO: should be faster if we define this
        // formats : "QR_CODE,PDF_417",
      };

      window.cordova.plugins.barcodeScanner.scan(
        this.handleScanSuccess,
        this.handleScanFailure,
        options
      );
    } else {
      console.log('BARCODE SCANNER NOT AVAILABLE!');
    }
  };

  render() {
    const { errorMessage } = this.state;
    const { label, fat, bgColor } = this.props;

    return (
      <div>
        {!!window.cordova && (
          <div style={{ marginBottom: 16 }}>
            <Button
              w="100%"
              h={fat && '100px'}
              bgColor={bgColor}
              onClick={this.scanBarcode}
            >
              <FontAwesomeIcon
                icon={faQrcode}
                style={{ fontSize: 24, marginRight: 8 }}
              />
              <span>{label || 'Skannaa QR- tai viivakoodi'}</span>
            </Button>
          </div>
        )}

        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </div>
    );
  }
}

const ErrorMessage = styled.p`
  color: #ff8492;
`;

QRCodeReader.propTypes = propTypes;

export default QRCodeReader;
